import LogoColor from '@/components/Bilderit-logo-hz-color-cropped.svg?react';
import LogoColorDarkMode from '@/components/Bilderit-logo-hz-color-cropped_darkmode.svg?react';
import { useTheme } from './theme-provider';

export const BilderitLogoHorizontal = (
  props: React.SVGProps<SVGSVGElement>
) => {
  const { theme } = useTheme();

  return theme === 'dark' ||
    (theme === 'system' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches) ? (
    <LogoColorDarkMode {...props} />
  ) : (
    <LogoColor {...props} />
  );
};
